import React from 'react'
import useForm from 'react-hook-form'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { withRouter } from 'react-router-dom'
import { faSuitcase, faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Container
} from 'reactstrap'
import PropTypes from 'prop-types'
import { createSupplier } from 'redux/actions/suppliers'
import SupplierForm from 'components/Suppliers/form'
import BackButton from 'components/BackButton'

const NewSupplier = ({ createSupplier, loading, history }) => {
  const { register, handleSubmit, errors, setError } = useForm()

  return (
    <Container className="pt-2 pt-md-5 pt-lg-6" fluid>
      <BackButton />
      <Row>
        <Col className="order-xl-1" xl="12">
          <Card className="bg-secondary shadow">
            <CardHeader className="bg-white border-0">
              <Row className="align-items-center">
                <Col xs="12">
                  <h3 className="mb-0">
                    <FontAwesomeIcon icon={faSuitcase} className="mr-1"/> Nuevo Proveedor<br/>
                    <Button
                      tag={Link}
                      color="primary"
                      to="/admin/suppliers"
                      size="sm"
                      className="mt-2"
                    >
                      <FontAwesomeIcon icon={faAngleLeft} className="mr-2"/>
                      Regresar a Lista
                    </Button>
                  </h3>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <SupplierForm
                onSubmit={handleSubmit(params => createSupplier(params, history, setError))}
                loading={loading}
                register={register}
                errors={errors}
                setError={setError}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

const mapStateToProps = ({ categories: { loading } }) => ({
  loading
})

const mapDispatchToProps = dispatch => ({
  createSupplier: (values, history, setError) => dispatch(createSupplier(values, history, setError))
})

NewSupplier.propTypes = {
  loading: PropTypes.bool,
  createSupplier: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
}

NewSupplier.defaultProps = {
  loading: false,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewSupplier))
